<template>
    <div>
        <router-link v-if="to !== ''" :to="this.to" class="router">
            <button @click="clicked()" :class="[this.type, {unicon: unicon}]" :style="customStyles" :disabled="loading">
                <div class="wrapper">
                    <span v-if="typeof icon !== 'undefined' && icon !== '' && !unicon" :class="['icon', icon]"></span>
                    <unicon v-if="typeof icon !== 'undefined' && icon !== '' && unicon" class="icon" :name="icon"
                            :fill="iconColor"></unicon>
                    <span>{{ title }}</span>
                    <div v-if="loading" class="loaderContainer" :style="{width: loaderSize}">
                        <svg class="spinner" viewBox="0 0 50 50"
                             :style="{width: loaderSize, height:loaderSize, margin: margin}">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </button>
        </router-link>
        <div v-else class="router">
            <button @click="clicked()" :class="[this.type, {unicon: unicon}]" :style="customStyles" :disabled="loading">
                <div class="wrapper">
                    <span v-if="typeof icon !== 'undefined' && icon !== '' && !unicon" :class="['icon', icon]"></span>
                    <unicon v-if="typeof icon !== 'undefined' && icon !== '' && unicon" class="icon" :name="icon"
                            :fill="iconColor"></unicon>
                    <span>{{ title }}</span>
                    <div v-if="loading" class="loaderContainer" :style="{width: loaderSize}">
                        <svg class="spinner" viewBox="0 0 50 50"
                             :style="{width: loaderSize, height:loaderSize, margin: margin}">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name: "AdaButton",
    props: {
        title: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            default: 'button'
        },
        icon: {
            type: String,
            required: false
        },
        iconColor: {
            type: String,
            default: '#fff'
        },
        customStyles: {
            type: [String, Object],
            required: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        loaderSize: {
            type: String,
            default: '20px'
        },
        unicon: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        margin() {
            let size = parseInt(this.loaderSize) / 2;
            return `-${size} 0 0 -${size}`
        }
    },
    methods: {
        clicked: function () {
            this.$emit('click');
        },
        getImgUrl: function (pic) {
            return require('../../assets/' + pic)
        }
    }
}
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
}

button {
   // z-index: 50000;
    font-size: 16px;
    padding: 8px 12px;
    min-width: 10em;
    cursor: pointer;
    display: flex;
    align-items: center;
    //width: 100%;
    height: 100%;
    position: relative;
    transition: width, margin 0.3s ease-in-out;
    border-radius: 4px;
    background-color: #00b6ed;

}

button:focus {
    outline: 0;
}

button.unicon {
    padding-left: 6px;
}

button:disabled {
    cursor: default;
}

.wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    margin: auto;
}

.router span {
    color: #fff;
    display: flex;
    height: 100%;
    align-items: center;
    line-height: 1;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}

.icon {
    margin-right: .5em;
    display: flex;
    height: 1em;
    align-items: center;
}

:deep( .invert) {
    padding: 9px 12px;
    border: 1px solid #00b6ed;
    background-color: white;
    color: #00b6ed;

    svg {
        fill: #00b6ed;
    }

    span {
        color: #00b6ed;
    }
}

:deep( .invertGrey) {
    padding: 9px 12px;
    border: none;
    background-color: transparent;
    color: #394956;

    svg {
        fill: #394956;
    }

    span {
        color: #394956;
    }
}


.button, .lightLayout {
    border: 2px solid #00b6ed;
    background-color: #00b6ed;
    //text-transform: uppercase;
    //padding: .9em
}

.lightLayout {
    background-color: #939BA2;
    border: 2px solid #939BA2;
}

.lightLayout span, .lightLayout icon {
    color: #fff;
}

.large {
    padding: 10px 10px;
    font-size: 13px;
    font-weight: 500;

    .icon {
        font-size: 18px;
    }
}


.fullWidthButton {
    color: #00b6ed;
    width: 100%;
    background-color: #fff;
    border: none;
    padding: 1em;

    .icon {
        font-size: 1.3rem !important;
    }

    span {
        color: inherit;
        font-size: 0.9rem;
        font-weight: bolder;
    }

    &:hover {
        color: #fff;
        background-color: #00b6ed;
    }

    &.tracking {
        background-color: #f6f7f8;
        padding: 0.7em 1em;
        border-top: 1px solid #eceef0;

        &:hover {
            color: #00b6ed;
            background-color: #fff;
        }
    }
}

.dialogConfirm, .dialogCancel {
    font-weight: 500;
    border-radius: 6px;
    text-transform: uppercase;
    padding: 5px 20px;
    font-size: 13px;
    border: 1px solid transparent;
}

.dialogConfirm {
    background: #00b6ed;
}

.dialogCancel {
    background: #394956;
}

.dialogConfirm .icon {
    font-size: 0.9rem;
}

.dialogCancel .icon {
    font-size: 1.2rem;
}

.blue {
    background: #00b6ed;
    border-color: #00b6ed;
    border-radius: 4px;
    border: none;
}

.pink {
    background: #d70364;
    border: 1px solid #d70364;
}

.grey {
    background-color: #394956;
    border: 1px solid #394956;
}

.excel {
    background-color: #008000;
    border: 1px solid #008000;
}

.mail {
    background-color: #FFAB00;
    border: 1px solid #FFAB00;
}

.purple {
    background-color: #752b77;
    border: 1px solid #752b77;
}

.outlined {
    background: transparent;
    border: 1px solid #394956;
    border-radius: 5px;
    padding: 8px 10px;
    font-weight: bold;
    font-size: 13px;
    min-width: auto;

    &.noPadding {
        padding: 0px 3px;
    }

    span {
        color: #394956;

        &.icon-visible {
            font-size: 24px;
            margin-right: 0;
        }
    }
}

.loaderContainer {
    margin-left: 10px;
    position: relative;

    .spinner {
        animation: rotate 2s linear infinite;
        z-index: 2;
        position: absolute;

        top: 50%;
        left: 50%;


        & .path {
            stroke: #fff;
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }

    }
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
    }
    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
    }
}

</style>